// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e3fc4bfb","952":"515d21c3"}[chunkId] + ".chunk.js";
};